import { darkPalette, lightPalette } from './palette'

const activeFocusShadow = (color: string) => `0 0 0 3px ${color}`

const elevationShadows = (shadow: typeof lightPalette.shadows | typeof darkPalette.shadows) => ({
  xs: `0 1px 2px 0 ${shadow.xs[1]}`,
  sm: `0 2px 4px -2px ${shadow.sm[2]}, 0 4px 6px -2px ${shadow.sm[1]}`,
  md: `0 4px 6px -4px ${shadow.md[2]}, 0 10px 15px -3px ${shadow.md[1]}`,
  lg: `0 8px 10px -6px ${shadow.lg[2]}, 0 20px 25px -5px ${shadow.lg[1]}`,
  xl: `0 16px 24px -8px ${shadow.xl[2]}, 0 32px 48px -8px ${shadow.xl[1]}`,
})

export const lightShadows = {
  ...elevationShadows(lightPalette.shadows),
  buttonInner: `0 2px 4px 0 ${lightPalette.effects['button-inner']} inset`,
  buttonDrop: `0 2px 8px 0 ${lightPalette.effects['button-drop']}`,
  activeFocus: activeFocusShadow(lightPalette.effects['active-focus']),
  activeAi: activeFocusShadow(lightPalette.effects['active-ai']),
  activeError: activeFocusShadow(lightPalette.effects['active-error']),
  activeSuccess: activeFocusShadow(lightPalette.effects['active-success']),
  activeBrand: activeFocusShadow(lightPalette.effects['active-brand']),
} as const

export const darkShadows = {
  ...elevationShadows(darkPalette.shadows),
  buttonInner: `0 2px 4px 0 ${darkPalette.effects['button-inner']} inset`,
  buttonDrop: `0 2px 8px 0 ${darkPalette.effects['button-drop']}`,
  activeFocus: activeFocusShadow(darkPalette.effects['active-focus']),
  activeAi: activeFocusShadow(darkPalette.effects['active-ai']),
  activeError: activeFocusShadow(darkPalette.effects['active-error']),
  activeSuccess: activeFocusShadow(darkPalette.effects['active-success']),
  activeBrand: activeFocusShadow(darkPalette.effects['active-brand']),
} as const
